import { CSSProperties } from "react";
import styled from "styled-components";
import theme from "styles/theme";

export const DocumentContainer = styled.div`
  margin-top: 5px;
  .ant-pagination {
    align-items: left;
    justify-content: left;
    display: flex;
    width: 100%;
    margin-top: 30px;
  }

  .ant-table-pagination.ant-pagination {
    margin-bottom: 0;
  }

  .ant-pagination-options {
    margin-left: auto;
  }
  .ant-pagination-total-text {
    margin-right: auto;
  }

  .ant-pagination-item {
    border: none;
  }
  .ant-pagination-item-link {
    border: none;
  }

  .trashIcon,
  .pencilEdit {
    color: ${(props) => props.theme["@default-color"]};
    cursor: pointer;
    &:hover {
      color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
`;

export const DocumentIcon: CSSProperties = {
  marginRight: "10px",
  alignItems: "center",
  color: theme["@primary-color-brand"],
};

export const FakeBtnConfirm: CSSProperties = {
  display: "none",
};
